import "./WireDiameterOpenArea.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import WireDiameterHero from "./sections/WireDiameterHero";
import WireDiameterGuide from "./sections/WireDiameterGuide";
import WireMeshQuoteCta from "./sections/WireMeshQuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function WireDiameterOpenAreaPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="WireDiameterOpenArea" />
      <WireDiameterHero />
      <WireDiameterGuide />
      <WireMeshQuoteCta />
      <Footer />
    </div>;
}